import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const stats = [{
  value: "2022",
  label: "Armsat1 Launch"
}, {
  value: "24/7",
  label: "Orbital Monitoring"
}, {
  value: "0.5m",
  label: "Image Resolution"
}];
export default function AboutTheMaster() {
  return <section data-section-id="235254" id="կամպանիայի-պատմություն" className="bg-background text-foreground py-16 md:py-24 lg:py-32 overflow-hidden light">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {}
          <div className="relative order-2 lg:order-1">
            {}
            <div className="absolute -inset-1 bg-gradient-to-r from-transparent via-primary/40 to-primary rounded-lg blur-md opacity-60 lg:opacity-80 transition-opacity duration-500"></div>
            
            {}
            <div className="relative h-[500px] lg:h-[700px] rounded-lg overflow-hidden bg-card border border-border shadow-xl">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/armsat1_orbital_launch.png" alt="Armsat1 satellite launch into orbit" className="w-full h-full object-cover grayscale-[10%] contrast-110 brightness-90" />
            </div>
          </div>

          {}
          <div className="flex flex-col space-y-8 order-1 lg:order-2">
            <div className="space-y-6">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold tracking-tighter text-foreground uppercase">
                Մեր Պատմությունը
              </h2>
              <div className="space-y-4 text-base text-muted-foreground font-default leading-relaxed">
                <p className="!text-2xl">&lt;&lt;Գեոկոսմոս&gt;&gt; ՓԲԸ-ն հանդիսանում է Հայաստանի տիեզերական հետազոտությունների և հեռազննման առաջամարտիկը: Մեր ճանապարհը սկսվել է տեսլականով՝ ապահովելու ինքնիշխան տիեզերական տվյալների հասանելիություն և բարձրակարգ գեոդեզիական լուծումներ:</p>
                <p className="!text-2xl">Արմսաթ 1-ի հաջող արձակումից մինչև ժամանակակից վերգետնյա կայանների շահագործումը, մենք կառուցում ենք թվային ենթակառուցվածք, որը հնարավորություն է տալիս ճշգրիտ քարտեզագրման և ռազմավարական հետախուզության միջոցով կայացնել հիմնավորված որոշումներ:</p>
              </div>
            </div>

            {}
            

            {}
            <div className="pt-4">
              <Button asChild size="lg" className="font-default w-full sm:w-auto bg-primary text-primary-foreground hover:opacity-90 rounded-md transition-all shadow-md">
                
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}